var StatusMessageService = (function () {
    function StatusMessageService() {
        this.key = 'status';
    }
    StatusMessageService.prototype.get = function () {
        return sessionStorage.getItem(this.key);
    };
    StatusMessageService.prototype.set = function (value) {
        sessionStorage.setItem(this.key, value);
    };
    StatusMessageService.prototype.remove = function () {
        sessionStorage.removeItem(this.key);
    };
    return StatusMessageService;
}());
export { StatusMessageService };
